// extracted by mini-css-extract-plugin
module.exports = {"cell":"style__cell__Ltaa3"};